import { render } from "./ent_imaging.vue?vue&type=template&id=461bd1b2&scoped=true"
import script from "./ent_imaging.vue?vue&type=script&lang=js"
export * from "./ent_imaging.vue?vue&type=script&lang=js"

import "./ent_imaging.vue?vue&type=style&index=0&id=461bd1b2&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-461bd1b2"]])

export default __exports__